import Header from "../Components/Header/Header";
import { useAuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer/Footer";

const PaymentCancel = () =>{
    const { user } = useAuthContext();
    let userName;
    if(user !=undefined)
    userName = user.firstName ? user.firstName : user.username;

    return(
        <div className="common-bg payment-status-page cancel-page dashboard-tone">
            <div className="container">
                <Header title ={`Hello ${userName}`} />
                <div className="padding30"></div>
                <div className="content-wrap white-bg">
                    <div className="content-wrap-inner subscription-form status-wrap">
                        <div className="head-title">Payment Canceled</div>
                        <p className="sub-title-text mb---20">No charges were made. You can try again when you are ready.</p>
                        <div className="subscription-item">
                            <div><span>Status :</span> Not Subscribed</div>
                            <div><span>Next step :</span> Retry premium checkout or go back to dashboard.</div>
                        </div>
                        <div className="thankyou-links mt---20">
                            <Link to="/go-premium"><button className="theme-btn">Try again</button></Link>
                            <Link to="/dashboard"><button className="button-right-arrow hover-bounce">Go to dashboard <span className="arrow-right"></span></button></Link>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}
export default PaymentCancel;
